// extracted by mini-css-extract-plugin
export default {"divHeader":"Message_divHeader__YGgEr","divBody":"Message_divBody__eVPOG"};